// Shared six-section customer navigation adapter.
import {
  getPharmacyNavigationGroups,
  type Permission,
  type PageOverrideMode,
  type Role,
} from "@medicorepay/shared";
import { HelpCircle, type LucideIcon } from "lucide-react";
import { getIcon } from "../lib/icon-registry";
import type { TenantSidebarConfig } from "../stores/authStore";

export interface ResolvedSidebarItem {
  name: string;
  href: string;
  icon: LucideIcon;
}

export interface ResolvedNavigationGroup {
  title: string;
  items: ResolvedSidebarItem[];
}

/**
 * The database-provided sidebar argument is retained for API compatibility but
 * intentionally ignored: routes and navigation are code-owned by one registry.
 */
export function buildNavigationGroups(
  _sidebarConfig: TenantSidebarConfig | undefined,
  enabledCapabilities: string[],
  hasPermission: (permission: Permission) => boolean,
  hasRole: (role: Role) => boolean,
  roleName?: string | null,
  pageOverrides?: Partial<Record<string, PageOverrideMode>>,
  disabledPageKeys?: string[],
): ResolvedNavigationGroup[] {
  return getPharmacyNavigationGroups({
    enabledCapabilities,
    hasPermission,
    hasRole,
    roleName,
    pageOverrides,
    disabledPageKeys,
  }).map((group) => ({
    title: group.title,
    items: group.items.map((item) => ({
      name: item.label,
      href: item.path,
      icon: getIcon(item.icon, HelpCircle),
    })),
  }));
}
